export default __webpack_public_path__ + "static/media/fluent_people-team-16-regular.8b8ddde0.svg";